// extracted by mini-css-extract-plugin
export default {"container":"HomeBlock_container__K-QY-","fullWidth":"HomeBlock_fullWidth__GdMYC","noPadding":"HomeBlock_noPadding__Misn1"};